import React from 'react';
import * as S from './customLTRow.styled';

type Props = {
    children: React.ReactNode;
    style?: React.CSSProperties;
    wrapperStyle?: React.CSSProperties;
    id?: string;
    onClick?: () => void;
};

const CustomLTRow = React.forwardRef<HTMLDivElement, Props>(
    ({ children, style, wrapperStyle, id, onClick }: Props, ref) => {
        return (
            <S.Row
                ref={ref}
                id={id}
                style={{
                    ...style,
                }}
                onClick={onClick}
                hasCursor={onClick ? true : false}
            >
                <S.Wrapper style={wrapperStyle}>{children}</S.Wrapper>
            </S.Row>
        );
    }
);

export { CustomLTRow };
